<template>
  <div class="footer">
    <div class="box">
      <div class="info">
        <div class="about">
          <a href="javascript:;">网站地图</a>
          <a href="javascript:;">常见问题</a>
          <a href="javascript:;">隐私声明</a>
          <a href="javascript:;">联系我们</a>
          <a href="javascript:;">证书查询</a>
          <a href="javascript:;">培训工作</a>
        </div>
        <p>
          {{copyright}}  <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff">{{recodenum}}</a><br>
          地址:{{address}}  
         
        </p>
        
        <div class="qrcode" id="qrcode">
          生成二维码
        </div>
        <a href="#">联 系 我 们</a>
      </div>

    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  name: "Footer",
  computed: {
    copyright() {
      return this.$store.getters.copyright;
    },
    recodenum() {
      return this.$store.getters.recodenum;
    },
    address() {
      return this.$store.getters.address;
    }
  },
  data() {
    return {
      
    }
  },
  mounted() {
    let dom = document.getElementById("qrcode")
    if (dom) dom.innerHTML = ''
    new QRCode('qrcode', {
      width: 127,
      height: 127,
      text:"http://www.cnbz.org.cn/"
    })

  },
  methods: {}
};
</script>
<style scoped>
.footer{
  position: relative;
  margin-top: 52px;
  padding-top: 10px;
  height: 285px;
  background: #2479D3;
}
.footer>.box{
  position: relative;
  padding: 27px 0 50px;
  height: 208px;
  background: #3872C7;
}
.footer>.box>.info{
  position: relative;
  margin: 0 auto;
  width: 1200px;
  height: 208px;
}
.footer>.box>.info>.about{
  position: relative;
  width: 950px;
  height: 128px;
  background: rgba(42, 105, 174,.3);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.footer>.box>.info>.about>a{
  position: relative;
  width: 158px;
  height: 128px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 128px;
  text-align: center;
}
.footer>.box>.info>.about>a:nth-child(-n+5)::after{
  position: absolute;
  width: 1px;
  height: 16px;
  background: #FFFFFF;
  content:"";
  top:57px;
  right: 0;
}
.footer>.box>.info>p{
  position: absolute;
  left: 10px;
  bottom: 0;
  width: 768px;
  height: 44px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}
.footer>.box>.info>.qrcode{
  position: absolute;
  top:38px;
  right:9px;
  width: 135px;
  height: 135px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer>.box>.info>a{
  position: absolute;
  top:193px;
  right: 9px;
  width: 135px;
  height: 18px;
  font-size: 18px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 18px;
  text-align: center;
}
.footer>.box>.info>a::before,.footer>.box>.info>a::after {
  position: absolute;
  top:7px;
  content: '';
  width: 4px;
  height: 4px;
  background: #FFFFFF;
  border-radius: 50%;
}
.footer>.box>.info>a::before{
  left: 0;
}
.footer>.box>.info>a::after{
  right: 0;
}
</style>
